import React from 'react';
import Reveal from './Reveal';
import IconBadge from './IconBadge';
import SectionHeader from './SectionHeader';
import EditableText from './EditableText';
import { resolveHomeIcon } from '../lib/homeIcons';

const FeatureGrid = ({ features, brandName }) => (
  <section className="section-y px-4 bg-slate-50">
    <div className="max-w-7xl mx-auto">
      <SectionHeader
        eyebrow="Nos atouts"
        eyebrowKey="home.features.eyebrow"
        title={`Pourquoi choisir ${brandName} ?`}
        titleKey="home.features.title"
        subtitle="Des ateliers de robotique pensés pour les enfants, approuvés par les parents et reconnus par nos partenaires éducatifs."
        subtitleKey="home.features.subtitle"
        reveal
      />

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10">
        {features.map((feature, i) => {
          const FeatureIcon = resolveHomeIcon(feature.icon);
          const n = i + 1;
          return (
            <Reveal key={feature.title} animation="fade-up" delay={i * 50}>
              <div className="h-full">
                <IconBadge
                  icon={FeatureIcon}
                  variant={i % 3 === 1 ? 'orange' : 'purple'}
                  size="md"
                  className="mb-4"
                />
                <EditableText
                  editKey={`home.features.${n}.title`}
                  defaultValue={feature.title}
                  as="h3"
                  className="text-slate-900 text-lg font-semibold mb-2"
                />
                <EditableText
                  editKey={`home.features.${n}.text`}
                  defaultValue={feature.description}
                  as="p"
                  multiline
                  className="text-slate-600 leading-relaxed text-sm"
                />
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default FeatureGrid;
